function parseBooleanFlag(value) {
  if (typeof value === 'boolean') {
    return value
  }

  if (typeof value !== 'string') {
    return false
  }

  const normalizedValue = value.trim().toLowerCase()

  return normalizedValue === '1' || normalizedValue === 'true' || normalizedValue === 'yes'
}

export const STANDARD_LIVE_SESSION_APP_OWNED_AGORA_FLAG =
  'standardLiveSessionAppOwnedAgora'

export function getStandardLiveSessionRtcMigrationDebugInfo({
  sessionRoutingDecision,
} = {}) {
  const routingFlagEnabled =
    sessionRoutingDecision?.featureFlags?.[STANDARD_LIVE_SESSION_APP_OWNED_AGORA_FLAG] === true

  const envFlagEnabled = parseBooleanFlag(
    import.meta.env.VITE_ENABLE_STANDARD_LIVE_SESSION_APP_OWNED_AGORA,
  )
  const envForceDisabled = parseBooleanFlag(
    import.meta.env.VITE_DISABLE_STANDARD_LIVE_SESSION_APP_OWNED_AGORA,
  )

  const enabled = envForceDisabled ? false : routingFlagEnabled || envFlagEnabled

  return {
    enabled,
    selectedSurface: enabled ? 'app-owned-agora-surface' : 'legacy-agora-component',
    routingFlagEnabled,
    envFlagEnabled,
    envForceDisabled,
  }
}

export function resolveStandardLiveSessionRtcMigrationEnabled({
  sessionRoutingDecision,
} = {}) {
  return getStandardLiveSessionRtcMigrationDebugInfo({ sessionRoutingDecision }).enabled
}
